<div class="mini-square-bar">
  <app-mini-square title="Chamados Em Espera" class="mini-square-bar-item" [value]="openCalls"
    link="/operador/chamados?statuses=A"></app-mini-square>
  <app-mini-square title="Chamados Em Atendimento" class="mini-square-bar-item" [value]="ongoingCalls"
    link="/operador/chamados?statuses=T"></app-mini-square>
  <app-mini-square title="Chamados Pendentes" class="mini-square-bar-item" [value]="pendingCalls"
    link="/operador/chamados?statuses=P"></app-mini-square>
  <app-mini-square title="Chamados Abertos Mês" class="mini-square-bar-item" [value]="thisMonthCalls"></app-mini-square>
  <app-mini-square title="Chamados Fechados Hoje" class="mini-square-bar-item"
    [value]="closedTodayCalls"></app-mini-square>
</div>
